/**
 * Central config for client-side polling intervals.
 *
 * Previously these were hardcoded in each page (2000 here, 30000 there,
 * 60000 somewhere else) which made tuning painful and inconsistent. They
 * now live in one place so a change is a single-line review. Values are in
 * milliseconds. All real-time data arrives via WebSocket; these polls are
 * fallback/refresh for REST-only state (connection status, orderbook
 * status probes, periodic revalidation).
 */

// Status probes (connection up/down, orderbook presence). Premiums and
// trigger state are pushed over WebSocket; these indicators can be slower so
// they do not contend with real-time WebSocket rendering.
export const STATUS_POLL_MS = 5000;

// Auto-dismiss sweep interval for the trade-execution notification queue.
// Each notification also has its own setTimeout, but browsers aggressively
// throttle timers in background tabs; this sweep handles the backlog when
// the tab becomes visible again.
export const NOTIFICATION_SWEEP_MS = 1000;

// Periodic revalidation for page-level datasets that are otherwise pushed
// via WebSocket. Useful as a safety net when a message was missed.
export const PAGE_REFRESH_MS = 30000;

// Slower-changing global values (FX rate, wallet balances etc.).
export const SLOW_REFRESH_MS = 60000;

// Polling cadence while WebSocket is disconnected (used by the fallback
// loop in Triggers).
export const WS_FALLBACK_POLL_MS = 5000;
